import { gql } from '@apollo/client';

export const SAFELIST_TWILIO_USER = gql`
  mutation SafelistTwilioUser($id: ID!) {
    safelistTwilioUser(id: $id) {
      ... on SafelistTwilioUserSuccess {
        __typename
        successMessage: message
      }
      ... on SafelistTwilioUserFailure {
        __typename
        failureMessage: message
        responseType
      }
      ... on NotFoundError {
        message
        responseType
        __typename
      }
      ... on InputValidationFailure {
        message
        responseType
        invalidFields {
          fieldName
          reason
          __typename
        }
        __typename
      }
      ... on AuthorizationFailure {
        message
        responseType
        __typename
      }
      __typename
    }
  }
`;
